module.exports = __webpack_public_path__ + "img/00banner full color.ac2fa6af.png";